import React from 'react';
import { motion } from 'framer-motion';

const WHATSAPP_NUMBER = '919491371038'; // country code + number, no + or spaces
const WHATSAPP_MESSAGE = 'Hi! I have a question about your courses.';

export default function Chatbot() {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-4 sm:right-6 w-14 h-14 rounded-full shadow-lg flex items-center justify-center z-50"
      style={{ backgroundColor: '#25D366' }}
      aria-label="Chat with us on WhatsApp"
    >
      {/* Official WhatsApp SVG icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-8 h-8"
        fill="white"
      >
        <path d="M16 0C7.164 0 0 7.163 0 16c0 2.822.736 5.477 2.023 7.785L0 32l8.385-2.195A15.938 15.938 0 0 0 16 32c8.836 0 16-7.163 16-16S24.836 0 16 0zm0 29.538a13.51 13.51 0 0 1-6.89-1.888l-.494-.292-5.125 1.342 1.368-4.988-.321-.513A13.47 13.47 0 0 1 2.462 16C2.462 8.532 8.532 2.462 16 2.462S29.538 8.532 29.538 16 23.468 29.538 16 29.538zm7.406-10.219c-.406-.203-2.402-1.185-2.774-1.32-.372-.136-.643-.203-.913.203-.271.406-1.048 1.32-1.285 1.591-.237.271-.474.305-.88.102-.406-.203-1.714-.632-3.266-2.015-1.207-1.076-2.022-2.405-2.259-2.811-.237-.406-.025-.625.178-.827.183-.181.406-.474.609-.711.203-.237.271-.406.406-.677.136-.271.068-.508-.034-.711-.102-.203-.913-2.202-1.251-3.015-.33-.792-.665-.685-.913-.697l-.777-.013c-.271 0-.711.102-1.083.508-.372.406-1.421 1.388-1.421 3.387s1.455 3.929 1.658 4.2c.203.271 2.863 4.372 6.935 6.131.969.418 1.725.668 2.314.855.972.309 1.857.265 2.557.161.78-.116 2.402-.982 2.741-1.93.338-.948.338-1.761.237-1.93-.102-.169-.372-.271-.779-.474z" />
      </svg>
    </motion.a>
  );
}